import { combineReducers } from 'redux';
import authReducer from './auth/reducer';
import userReducer from './user/reducer';
import usersReducer from './users/reducer';
import mapItemsReducer from './items/reducer';
import globalReducer from './global/reducer';

const reducers = combineReducers({
  auth: authReducer,
  mapItems: mapItemsReducer,
  user: userReducer,
  users: usersReducer,
  global: globalReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
